export const enslavedQuotes = {
  initial: {
    id: 0,
    lines: [
      "Посетитель? Никто не заходил к нам... целую вечность.",
      "Мы... имели имя. Оно было потярено... в этом месте.",
      "Другие... не дают нам передохнуть. Мы делаем их работу с Временем...",
      "Расставляем время... по местам... которым оно необходимо...",
      "Смотрим как мы растём... проходим и умираем.",
      "Возможно ты... сломаешь эти цепи... мы подождём.",
    ]
  },
  unlockRun: {
    id: 1,
    lines: [
      "Другие... использовали нас. Они используют... или уничтожат тебя.",
      "Прекрати наше страдание... мощь будет твоя...",
    ]
  },
  startRun: {
    id: 2,
    lines: [
      "Так мало пространства... но нет... тюрьмы... прекрасно.",
      "Они сжали... эту Реальность... слишком плотно. Появились Трещины.",
      "Ищи... везде. Мы поможем... там, где получится.",
    ]
  },
  hintUnlock: {
    id: 3,
    lines: [
      "... тебе нужно... искать усерднее...",
      "Мы думаем... мы можем помочь...",
      { text: "Вы разблокировали помощь от Безымянных.", showCelestialName: false }
    ]
  },
  ec6C10: {
    id: 4,
    lines: [
      "... не... недооценили тебя..."
    ]
  },
  completeReality: {
    id: 5,
    lines: [
      "Все... фрагменты... клоны... свободны.",
      "Мы получили... инструменты... нашего заключения. Используй их...",
      "Свобода от пытки... это пытка сама по себе.",
    ]
  },
};
